import React from "react";
import { Field } from "formik"
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import { Spin, Card, Button, Typography, Modal, Select, Row, Col, Input } from "antd";

import { useQuery } from "../../../../utils";
import UserForm from "../../../../Components/UserForm";
import DistrictSubProperty from "../../../../Components/DistrictSubProperty";
import InputLabel from '../../../../Components/FloatingSelectLabel/FloatingSelectLabel';
import {
  getEtoOrTiDetails,
} from "../../../../actionCreators/ETO";
import { getTIOfDistrict, updateTI, resetUpdateTI } from "../../../../actionCreators/TaxInspector"
import { getDistricts } from "../../../../actionCreators/DropDown";
import { getZonesOfDistrict } from "../../../../actionCreators/Zones";
import { getCirclesOfDistrict, assignCirclesToTI, resetAssignCirclesToTI } from '../../../../actionCreators/Circles';

import Notification from "../../../../Components/Notification"

function EditTI({
  getEtoOrTiDetails,
  EtoOrTiDetails,
  getDistricts,
  districts,
  getCirclesOfDistrict,
  circlesOfDistrict,
  getTIOfDistrict,
  tiOfDistrict,
  assignCirclesToTI, //bugFixing
  assignCirclesToTIResponse,
  updateTI,
  updateTIResponse,
  resetUpdateTI,
  resetAssignCirclesToTI
}) {
  let timeout;
  const styles = {
    titleButtonParent: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    uploadButton: {
      padding: "7px 18px",
      background: "#284F68",
      color: "white",
      borderRadius: "5px",
      fontWeight: "500",
      fontSize: "15px",
      cursor: "pointer",
      marginRight: "8px",
    },
    contentWrapper: {
      marginLeft: "10px",
      marginRight: "10px",
    },
    titleText: {
      color: "#9e9e9e",
    },
    firstButton: {
      marginRight: "10px",
    },
    assignmentTitle: {
      fontSize: "20px",
    },
  };

  const query = useQuery();

  const handleSubmit = (identityForm, assignmentForm) => {
    const obj = {
      id: query.get("id"),
      fullName: identityForm?.name,
      email: identityForm?.email,
      phone: identityForm?.phone,
      status: identityForm?.status === 1 ? "active" : "inactive",
      circlesId: assignmentForm?.circles?.map((x) => x?.id) ?? [],
    };
    updateTI(obj)
  };

  const history = useHistory();
  const [identityForm, setIdentityForm] = React.useState(null);
  const [assignmentForm, setAssignmentForm] = React.useState(null);
  const [disableInviteButton, setDisableInviteButton] = React.useState(false);
  //reassigned modal states
  const [reassignedETO, setReassignedETO] = React.useState(null);
  const [showReassignedModal, setShowReassignedModal] = React.useState(false);
  const [multiZonesInputActive, setMultiZonesInputActive] = React.useState(false);
  const [reassignedStatusSelectActive, setReassignedStatusSelectActive] = React.useState(false)
  const [multipleReassignedStructure, setMultipleReassignedStructure] = React.useState([]);
  const [disableMultipleAssignmentButton, setDisableMultipleAssignmentButton] = React.useState(true);
  const [selectedCancelZone, setSelectedCancelZone] = React.useState(null); //only selected when cancel.

  React.useEffect(() => {
    getDistricts();
  }, []);

  React.useEffect(() => {
    getEtoOrTiDetails({ userId: query.get("id") });
  }, [query]);

  React.useEffect(() => {
    if (selectedCancelZone) {
      getTIOfDistrict({
        districtId: EtoOrTiDetails?.data?.data[0]?.districts[0]?.id,
      });
      setShowReassignedModal(true)
    }
  }, [selectedCancelZone])
  React.useEffect(() => {
    if (assignCirclesToTIResponse?.data?.success === true) {
      getEtoOrTiDetails({ userId: query.get("id") });
      Notification(true, 'Success', 'Circles(s) reassigned successfully')
      // history.goBack()
      resetAssignCirclesToTI();
    } else if ((assignCirclesToTIResponse?.data?.success === false) || !assignCirclesToTIResponse?.loading && assignCirclesToTIResponse?.error != null) {
      Notification(false, 'Error', 'Circles(s) cannot be reassigned');
      resetAssignCirclesToTI();
    }
  }, [assignCirclesToTIResponse])

  React.useEffect(() => {
    if (updateTIResponse?.data?.data?.success === true) {
      getEtoOrTiDetails({ userId: query.get("id") });
      Notification(true, 'Success', 'Tax Inspector updated')
      history.goBack()
      resetUpdateTI();
    } else if (updateTIResponse?.data?.data?.success === false) {
      Notification(false, 'Error', 'Error in Updation')
      resetUpdateTI();
    }
  }, [updateTIResponse])

  React.useEffect(() => {
    if (showReassignedModal && [undefined, null].includes(selectedCancelZone)) {
      setMultipleReassignedStructure(
        EtoOrTiDetails?.data?.data[0]?.circles?.map(x => Object.assign(x, { tiId: null }))
      )
    }
  }, [showReassignedModal])


  const handleMultipleReassignedStructureChange = (index) => (value) => {
    let filter = multipleReassignedStructure;
    filter[index]['tiId'] = value;
    setMultipleReassignedStructure(filter);
    setDisableMultipleAssignmentButton(handleDisable(filter))
  }

  const handleDisable = (array) => {
    const val = array?.find(x => x?.tiId === null)
    if ([undefined, null, -1].includes(val)) {
      return false;
    }
    return true;
  }


  const handleTiSearch = (value) => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  
    const fetchTiOfDistrict = () => {
      getTIOfDistrict({
        districtId: EtoOrTiDetails?.data?.data[0]?.districts[0]?.id,
        search: value
      });
    }
  
    timeout = setTimeout(fetchTiOfDistrict, 1000);
  };

  if (
    [undefined, null].includes(EtoOrTiDetails?.data?.data[0]) ||
    EtoOrTiDetails?.loading || updateTIResponse?.loading || assignCirclesToTIResponse?.loading
  )
    return (
      <div className="spin-loader">
        <Spin size="large" />
      </div>
    );
  else
    return (
      <React.Fragment>
        <div style={styles.titleButtonParent}>
          <div>
            <Typography className="heading">
              <span style={styles.titleText}>Tax Inspector</span>
              {EtoOrTiDetails?.loading || ` / ${EtoOrTiDetails?.data?.data[0]?.fullName}`}
            </Typography>
          </div>
          <div>
            <Button
              style={styles.firstButton}
              danger
              color={"orange"}
              size={"large"}
              onClick={() => history.goBack()}
            >
              Cancel
            </Button>
            <Button
              style={!disableInviteButton ? styles.uploadButton : {}}
              type="primary"
              size={"large"}
              onClick={() => handleSubmit(identityForm, assignmentForm)}
              disabled={disableInviteButton}
            >
              UPDATE
            </Button>
          </div>
        </div>
        <Card bordered={false}>
          <UserForm
            data={EtoOrTiDetails?.data?.data[0]}
            columnConfig={{
              name: { isRequired: true, isDisabled: false },
              email: { isRequired: true, isDisabled: true },
              phone: { isRequired: true, isDisabled: false },
              status: { isDisabled: false },
            }}
            updateFormState={(x) => setIdentityForm(x)}
            toggleUpdateDisability={(x) => setDisableInviteButton(x)}
            requestDisableStatus={() => {
              getTIOfDistrict({
                districtId: EtoOrTiDetails?.data?.data[0]?.districts[0]?.id,
              });
              setShowReassignedModal(true);
            }}
            disableStatusAllow={
              EtoOrTiDetails?.data?.data[0]?.circles?.length > 0 ?? false
            }
          />
          <div style={styles.assignmentTitle}>Assignment</div>
          <DistrictSubProperty
            data={EtoOrTiDetails?.data?.data[0]}
            initialDistrictValue={districts?.data}
            subPropertyOfDistrict={circlesOfDistrict?.data}  //from zonesOfDistrict
            getSubPropertyOfDistrict={(x) => getCirclesOfDistrict({ districtId: x })} //from getZonesOfDistrict
            updateFormState={(x) => setAssignmentForm(x)}
            cancelSelectedSubProperty={(x) => setSelectedCancelZone(x)}
            isCircle={true}
            isEditMode={true}
          />
        </Card>

        {/* zones reassign Model */}
        {

          [undefined, null].includes(selectedCancelZone) ?
            <Modal
              destroyOnClose={true}
              title={"Mark User Inactive"}
              visible={showReassignedModal}
              okText={"CONFIRM REPLACEMENT"}
              onOk={() => {
                assignCirclesToTI({ data: multipleReassignedStructure?.map((x) => ({ circleId: x?.id, tiId: x?.tiId })) })
                setSelectedCancelZone(null);
                setMultipleReassignedStructure([])
                setShowReassignedModal(false);
                setDisableMultipleAssignmentButton(true)
              }}
              onCancel={() => {
                setSelectedCancelZone(null);
                setShowReassignedModal(false);
                setMultipleReassignedStructure([])
                setDisableMultipleAssignmentButton(true)
              }}
              // handleDisable(multipleReassignedStructure)
              okButtonProps={{
                style:
                  disableMultipleAssignmentButton
                    ? { display: 'none' } : { display: '' }
              }}
              width="60%"
            >
              {
                [undefined, null, 0].includes(multipleReassignedStructure?.length) ||
                  [undefined, null].includes(tiOfDistrict?.data) ? (
                  <div>
                    <Row gutter={16}>
                      <Col
                        span={24}
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Spin size="small" />
                      </Col>
                    </Row>
                  </div>
                ) : (
                  <div>
                    <Row gutter={16}>
                      <Col span={24} style={{ marginBottom: "5px" }}>
                        <Typography.Text>
                          You are making a user inactive.Please reassign the circle(s) and property assessment to another Tax Inspector
                        </Typography.Text>
                      </Col>

                      {multipleReassignedStructure?.map((x, index) =>
                        <>
                          <Col span={12} className="column-left">
                            <div
                              style={{ marginTop: "26px", height: "60px" }}
                            >
                              <InputLabel
                                value={
                                  x?.name
                                } //value of all zones that we should assign
                                labelText="Circles"
                                active={multiZonesInputActive}
                              >
                                <Input
                                  style={{ height: "60px", paddingTop: "13px" }}
                                  value={
                                    x?.name
                                  }
                                />
                              </InputLabel>
                            </div>
                          </Col>
                          <Col span={12} className="column-right">
                            <div
                              style={{ marginTop: "25px", height: "40px" }}
                            >
                              <InputLabel
                                active={true}
                                // value={multipleReassignedStructure[index]?.tiId}
                                labelText="Tax Inspector"
                              >
                                <Select
                                  // value={multipleReassignedStructure[index]?.tiId}
                                  onChange={handleMultipleReassignedStructureChange(index)}
                                  size="large"
                                >
                                  {tiOfDistrict?.data?.data?.map((x) => (
                                    <Select.Option disabled={EtoOrTiDetails?.data?.data[0]?.id === x?.id || !x.is_active} value={x?.id}>{x?.name}</Select.Option>
                                  ))}
                                </Select>
                              </InputLabel>
                            </div>
                          </Col>
                        </>
                      )}



                      <Col span={24} style={{ marginTop: "15px" }}>
                        <Typography.Text>
                          You can add a new TI first and then come back to choose a replacement
                        </Typography.Text>
                      </Col>
                    </Row>
                  </div>
                )
              }
            </Modal>
            :
            <Modal
              title={"Reassign Circle"}
              visible={showReassignedModal}
              okText={"CONFIRM REPLACEMENT"}
              onOk={() => {
                //Why data is sent as an array not as an object? should be like assignCirclesToTI({ tiId: reassignedETO, circleId: selectedCancelZone?.id });
                assignCirclesToTI({ data: [{ tiId: reassignedETO, circleId: selectedCancelZone?.id }] }); //dispatch call with single zone.
                setSelectedCancelZone(null);
                setShowReassignedModal(false);
              }}
              onCancel={() => {
                setSelectedCancelZone(null);
                setShowReassignedModal(false);
              }}
              okButtonProps={{ style: [undefined, null].includes(reassignedETO) ? { display: 'none' } : { display: '' } }}
              width="60%"
            >
              {[undefined, null].includes(tiOfDistrict?.data) ? (
                <div>
                  <Row gutter={16}>
                    <Col
                      span={24}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Spin size="small" />
                    </Col>
                  </Row>
                </div>
              ) : (
                <div>
                  <Row gutter={16}>
                    <Col span={24} style={{ marginBottom: "5px" }}>
                      <Typography.Text>
                        Please reassign the circle(s) and property assessment to another TI.
                      </Typography.Text>
                    </Col>

                    <Col span={12} className="column-left">
                      <div
                        onFocus={() => {
                          setMultiZonesInputActive(true);
                        }}
                        onBlur={() => {
                          setMultiZonesInputActive(false);
                        }}
                        style={{ marginTop: "26px", height: "60px" }}
                      >

                        <InputLabel
                          value={[undefined, null].includes(selectedCancelZone) ?
                            EtoOrTiDetails?.data?.data[0]?.circles?.map(x => x?.name)
                            :
                            selectedCancelZone?.name} //value of all zones that we should assign
                          labelText="Circles"
                          active={multiZonesInputActive}
                        >
                          <Input
                            style={{ height: "60px", paddingTop: "13px" }}
                            value={
                              [undefined, null].includes(selectedCancelZone) ?
                                EtoOrTiDetails?.data?.data[0]?.circles?.map(x => x?.name)
                                :
                                selectedCancelZone?.name
                            }
                          />
                        </InputLabel>
                      </div>
                    </Col>
                    <Col span={12} className="column-right">
                      <div
                        onFocus={() => {
                          setReassignedStatusSelectActive(true);
                        }}
                        onBlur={() => {
                          setReassignedStatusSelectActive(false);
                        }}
                        style={{ marginTop: "25px", height: "40px" }}
                      >
                        <InputLabel
                          value={reassignedETO}
                          labelText="Tax Inspector"
                          active={reassignedStatusSelectActive}
                        >
                          <Select
                            value={reassignedETO}
                            onChange={setReassignedETO}
                            size="large"
                            showSearch
                            filterOption={false}
                            onSearch={handleTiSearch}
                          >
                            {tiOfDistrict?.data?.data?.map((x) => (
                              <Select.Option disabled={EtoOrTiDetails?.data?.data[0]?.id === x?.id } value={x?.id}>
                                <div style={{ display: "flex", flexDirection: 'column' }}>
                                  <span>{x?.name}</span>
                                  <span style={{ color: 'gray', fontSize: 'small' }}>{x?.email}</span>
                                </div>
                              </Select.Option>
                            ))}
                          </Select>
                        </InputLabel>
                      </div>
                    </Col>


                    <Col span={24} style={{ marginTop: "15px" }}>
                      <Typography.Text>
                        You can add a new TI first and then come back to choose a replacement
                      </Typography.Text>
                    </Col>
                  </Row>
                </div>
              )}
            </Modal>
        }
        {/* zones reassign Model */}
      </React.Fragment >
    );
}

const mapStateToProps = ({
  user: user,
  eto: { EtoOrTiDetails, },
  taxInspector: { tiOfDistrict, updateTIResponse },
  dropDown: { districts },
  circles: { circlesOfDistrict, assignCirclesToTIResponse },
  zones: { zonesOfDistrict },
}) => ({
  user,
  EtoOrTiDetails,
  user,
  districts,
  zonesOfDistrict,
  tiOfDistrict,
  updateTIResponse,
  circlesOfDistrict,
  assignCirclesToTIResponse
});

const mapDispatchToProps = (dispatch) => ({
  getEtoOrTiDetails: bindActionCreators(getEtoOrTiDetails, dispatch),

  getDistricts: bindActionCreators(getDistricts, dispatch),
  getZonesOfDistrict: bindActionCreators(getZonesOfDistrict, dispatch),
  getTIOfDistrict: bindActionCreators(getTIOfDistrict, dispatch),
  assignCirclesToTI: bindActionCreators(assignCirclesToTI, dispatch),
  updateTI: bindActionCreators(updateTI, dispatch),
  getCirclesOfDistrict: bindActionCreators(getCirclesOfDistrict, dispatch),
  resetUpdateTI: bindActionCreators(resetUpdateTI, dispatch),
  resetAssignCirclesToTI: bindActionCreators(resetAssignCirclesToTI, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EditTI);
